import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://diningtracker.co.za';

const SEO = ({ title, description, path = '', type = 'website', image, noindex = false }) => {
  const fullTitle = title ? `${title} — Dining Tracker` : 'Dining Tracker — Discover Cape Town Restaurants';
  const desc = description || 'Discover Cape Town\'s best restaurants, plan visits, log dining experiences with photos and ratings, and build your personal dining history.';
  const url = `${BASE_URL}${path}`;
  const img = image || `${BASE_URL}/og-image.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default SEO;
